function initRecaptchaForm() {
  const formSelector = '.js-recaptcha-form';
  const recaptchaInputSelector = '[name="recaptcha"]';

  const formList = document.querySelectorAll(formSelector);

  if (!formList.length) return;

  for (let i = 0; i < formList.length; i++) {
    const form = formList[i];

    const recaptchaInput = form.querySelector(recaptchaInputSelector);

    if (!recaptchaInput || !recaptchaInput.hasAttribute('data-sitekey')) continue;

    const siteKey = recaptchaInput.getAttribute('data-sitekey');

    form.addEventListener('submit', (e) => {
      e.preventDefault();

      if (!window.hasOwnProperty('grecaptcha')) {
        form.submit();
        return;
      }

      const action = form.getAttribute('data-action') || form.getAttribute('action');

      grecaptcha.ready(() => {
        grecaptcha
          .execute(siteKey, {action: action})
          .then(token => {
            recaptchaInput.value = token;
            form.submit();
          });
      });
    });
  }
}

function initInputCount() {
  const inputSelector = '.js-input-count';
  const helperSelector = '.js-input-count-helper';
  const helperCurrentSelector = '.js-input-count-helper-current';
  const invalidClass = 'form__counter_error';

  const inputList = document.querySelectorAll(inputSelector);

  if (!inputList.length) return;

  for (let i = 0; i < inputList.length; i++) {
    const input = inputList[i];

    let maxLength = +input.getAttribute('data-max')
      || +input.getAttribute('max')
      || +input.getAttribute('maxlength');

    if (!maxLength) {
      maxLength = 65535;
    }

    input.addEventListener('input', () => {
      const parent = input.parentElement;
      const helper = parent.querySelector(helperSelector);
      const helperCurrent = parent.querySelector(helperCurrentSelector);

      if (!helper || !helperCurrent) return;

      const currentLength = input.value.length;

      helperCurrent.textContent = currentLength;
      helper.classList.toggle(invalidClass, (currentLength > maxLength));
    });
  }
}

export {initRecaptchaForm, initInputCount};
